<!--/* eslint-disable */-->
<template>
  <vx-card class="mt-4" title="Análise Setorial">
    <div class="flex gap-4 items-center">

      <div>
        <date-picker
          v-model="scoreForm.date"
          name="data"
          v-validate="'required'"
          :append-to-body="false"
          class="w-full z-index-bg"
          :disabled-date="disabledAfterToday"/>
      </div>

      <div>
        <vs-select
          v-model="scoreForm.score"
          name="valor"
          class="w-full">
          <vs-select-item :key="index" :value="score.score" :text="score.description" v-for="(score, index) in sectorValues" />
        </vs-select>
      </div>

      <div>
        <vs-button
          class="bg-primary"
          :disabled="companyGuid == null"
          @click="validate">Cadastrar</vs-button>
      </div>

    </div>

    <div>
      <vs-table
        stripe
        v-model="selected"
        :data="scores"
        @selected="handleComplianceSelected"
        class="mt-4"
        noDataText="Não há valores cadastrados para esta empresa.">

        <template slot="thead">
          <th></th>
          <th>Data</th>
          <th>Nota</th>
          <th>Apagar</th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr]">
              <vs-checkbox
                v-model="data[indextr].checked"
                disabled="true"
              />
            </vs-td>
            <vs-td :data="data[indextr].date">
              {{tr.date | formatDate}}
            </vs-td>
            <vs-td :data="data[indextr].value">
              <span v-if="tr.description != null">{{tr.description}}</span>
              <span v-else>Sem Nota</span>
            </vs-td>
            <vs-td><span role="button" style="cursor: pointer; color: blue" @click="deleteScore(tr)">Apagar Nota</span></vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="mt-2">
        <p>Selecione uma nota antes de enviar a análise</p>
      </div>

    </div>
  </vx-card>

</template>

<script>
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'
import moment from 'moment'
import NumericInput from './NumericInput'

export default {
  name: 'SectorAnalysisForm',
  props: {
    companyGuid: String,
  },
  watch: {
    nullScore() {
      if (this.nullScore === true) {
        this.scoreForm.value = null
        this.convertSerasa = false
      }
    },

    companyGuid() {
      this.getValues()
    }
  },
  components: {
    DatePicker,
    moment,
    NumericInput
  },
  mounted () {
    this.getSectorAnalysisValues()
    this.getValues()
  },
  data () {
    return {
      selected: null,
      nullScore: false,
      convertSerasa: false,
      scoreForm: {
        companyGuid: null,
        date: null,
        value: null
      },
      score: {
        company: {
          guid: null
        },
        date: null,
        value: null
      },
      scores: [],
      sectorValues: [],
      sectorAnalysisValues: []
    }
  },
  methods: {
    disabledAfterToday (date) {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return date > today
    },

    getSectorAnalysisValues() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/sector-analysis/values`)
        .then((response) => {
          this.sectorValues = response.data
        })
    },

    getSelected() {
      return this.selected
    },

    getValues () {
      if (this.companyGuid == null) return

      this.scoreForm.companyGuid = this.companyGuid
      axios.get(`${process.env.VUE_APP_API}/api/v1/sector-analysis/${this.companyGuid}`)
        .then((response) => {
          this.scores = response.data
        })

    },

    validate () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.setValue()
        } else {
          for (const idx in this.errors.items) {
            this.$vs.notify({
              color: 'danger',
              text: this.errors.items[idx].msg
            })
          }
        }
      })
    },

    setValue () {
      if (this.companyGuid == null) {
        this.$vs.notify({
          color: 'danger',
          text: 'Selecione um garantidor.'
        })
        return
      }

      this.scoreForm.companyGuid = this.companyGuid
      axios.post(`${process.env.VUE_APP_API}/api/v1/sector-analysis`, this.scoreForm)
        .then((response) => {
          this.scores = response.data
          for (let i = 0; i < this.scores.length; i++) {
            this.scores[i].checked = false
          }
        })
        .finally(() => {
          this.getValues()
        })
    },

    deleteScore(tr) {
      axios.delete(`${process.env.VUE_APP_API}/api/v1/sector-analysis/` + tr.guid)
        .then((response) => {
          this.scores = response.data
        })
        .finally(() => {
          this.getValues()
        })
    },

    handleComplianceSelected (tr) {
      for (let i = 0; i < this.scores.length; i++) {
        this.scores[i].checked = tr.guid === this.scores[i].guid;
      }
    },

  }
}
</script>

<style scoped>
.z-index-bg {
  z-index: 500;
}
</style>
